import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Modal, Input, message } from 'antd';
import { UpdateByIdApi } from '../../../utils/api';

const { TextArea } = Input;

const NotesModal = ({ visible, onCancel, appointmentId, currentNotes, onSuccess }) => {
  const [notes, setNotes] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (visible) {
      setNotes(currentNotes || '');
    }
  }, [visible, currentNotes]);

  const handleSave = async () => {
    if (!notes.trim()) {
      message.error('Please enter a note');
      return;
    }

    setLoading(true);
    try {
      await UpdateByIdApi({
        Query: `admin/appointment/${appointmentId}`,
        obj: { notes }
      });

      message.success('Notes updated successfully');
      onSuccess(notes);
      setNotes('');
    } catch (error) {
      console.error('Error updating notes:', error);
      message.error('Failed to update notes');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setNotes(currentNotes || '');
    onCancel();
  };

  if (!visible) return null;

  return createPortal(
    <Modal
      title="Action Report / Notes"
      open={visible}
      onOk={handleSave}
      onCancel={handleCancel}
      confirmLoading={loading}
      okText="Save Notes"
      cancelText="Cancel"
      centered
      zIndex={9999}
      styles={{
        body: { maxHeight: '80vh' },
        content: { width: '900px' }
      }}
    >
      <div style={{ marginTop: 16 }}>
        <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>
          Add your notes here:
        </label>
        <TextArea
          rows={20}
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          placeholder="Enter notes or action report..."
        />
      </div>
    </Modal>,
    document.body
  );
};

export default NotesModal;
